import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const lobby = React.lazy(() => import("@kaltura/mediaspace-features-invite-to-media"));

export const renderLobbyPage = getDsLayoutComponentRenderer(lobby);
